// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"search-banners_uk-open__iHafN","grecaptcha-badge":"search-banners_grecaptcha-badge__5TXCc","root":"search-banners_root__Z2jcl","slider":"search-banners_slider__jKlY8","banner":"search-banners_banner__oda4u","dots":"search-banners_dots__hwUGa","dot":"search-banners_dot__zZc0t","activeDot":"search-banners_activeDot__1dogB"};
    if(module.hot) {
      // 1793877059866
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  